import gdprService from 'services/gdprService'
import * as actionTypes from '../actions/actionTypes'
import { userError } from '../../utils/userError'

// Fetches the document the service points at. A failed request or a non-2xx file is a
// load failure the screen shows (with a reference), never an empty box.
const fetchDocument = getPath =>
  getPath().then(data =>
    fetch(data.path).then(res => {
      if (!res.ok) {
        const error = new Error(`Document request failed (${res.status})`)
        error.status = res.status
        error.response = res
        throw error
      }
      return res.text()
    })
  )

const documentLoadFailed = error => ({
  type: actionTypes.GDPR_LOAD_FAILED,
  loadError: userError(error, {
    area: 'ACCOUNT',
    code: 'ACCOUNT-TERMS-LOAD-FAILED',
    title: "We couldn't load the terms",
    guidance: 'Try again. You can read and accept them once they load.',
  }),
})

export const fetchingPrivacyPolicy = () =>{
  return dispatch =>{
    dispatch({ type: actionTypes.GDPR_LOAD_STARTED })
    return fetchDocument(() => gdprService.getPrivacyPolicy())
    .then(privacyContent => dispatch(successFetchingPrivacyPolicy(privacyContent)))
    .catch(err => dispatch(documentLoadFailed(err)))
  }
}

const successFetchingPrivacyPolicy = privacyPolicy => {
  return {
    type: actionTypes.GDPR_SUCCESS_PRIVACY_POLICY,
    privacyPolicy : privacyPolicy
  }
}

export const fetchingTermsConditions = () => {
  return dispatch => {
    dispatch({ type: actionTypes.GDPR_LOAD_STARTED })
    return fetchDocument(() => gdprService.getTermsConditions())
    .then(termsConditionsContent => dispatch(successFetchingTermsConditions(termsConditionsContent)))
    .catch(err => dispatch(documentLoadFailed(err)))
  }
}


const successFetchingTermsConditions = termsConditions => {
  return {
    type: actionTypes.GDPR_SUCCESS_TERMS_CONDITIONS,
    termsConditions : termsConditions
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Gdpr.js